import { GameCategoryType } from "@golden/gdk-base";
export var ActivityNewYearStatusType;
(function (ActivityNewYearStatusType) {
    ActivityNewYearStatusType["NO_USE"] = "no_use";
    ActivityNewYearStatusType["NOT_RECEIVED"] = "not_received";
    ActivityNewYearStatusType["RECEIVED"] = "received";
    ActivityNewYearStatusType["LOSE"] = "lose";
    ActivityNewYearStatusType["EXPIRED"] = "expired";
})(ActivityNewYearStatusType || (ActivityNewYearStatusType = {}));
export var ActivityNewYearCategoryType;
(function (ActivityNewYearCategoryType) {
    ActivityNewYearCategoryType[ActivityNewYearCategoryType["LIVE"] = 1] = "LIVE";
    ActivityNewYearCategoryType[ActivityNewYearCategoryType["VIDEO_AND_CARD"] = 2] = "VIDEO_AND_CARD";
    ActivityNewYearCategoryType[ActivityNewYearCategoryType["SPORT_AND_ESPORT"] = 3] = "SPORT_AND_ESPORT";
})(ActivityNewYearCategoryType || (ActivityNewYearCategoryType = {}));
//# sourceMappingURL=ActivityNewYear.js.map